"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndustrySpecificPotencyValues = exports.formatPotencyValue = exports.formatValueRange = exports.isValidJson = void 0;
const companies_1 = require("@getgreenline/companies");
function isValidJson(str) {
    try {
        if (typeof str !== 'string') {
            return str;
        }
        const parsed = JSON.parse(str);
        return parsed;
    }
    catch (e) {
        return null;
    }
}
exports.isValidJson = isValidJson;
const formatValueRange = (params) => {
    const { singleValue, minValue, maxValue, unit, separator = '-', unlimitedText, showZeroForMissingMin = false, } = params;
    if (minValue !== undefined && minValue !== null && maxValue !== undefined && maxValue !== null) {
        return `${minValue}${unit} ${separator} ${maxValue}${unit}`;
    }
    if (singleValue !== undefined && singleValue !== null) {
        return `${singleValue}${unit}`;
    }
    if (minValue !== undefined && minValue !== null && unlimitedText) {
        return `${minValue}${unit} ${separator} ${unlimitedText}`;
    }
    if (maxValue !== undefined && maxValue !== null && showZeroForMissingMin) {
        return `0${unit} ${separator} ${maxValue}${unit}`;
    }
    return null;
};
exports.formatValueRange = formatValueRange;
const formatPotencyValue = (metaData, key, minKey, maxKey, defaultUnit) => {
    const isProof = key === 'proof' || minKey === 'minProof';
    const unit = isProof ? '' : (metaData === null || metaData === void 0 ? void 0 : metaData.unit) || defaultUnit;
    const showMaxMin = (metaData === null || metaData === void 0 ? void 0 : metaData.showMaxMin) === 'true';
    return (0, exports.formatValueRange)({
        singleValue: showMaxMin ? undefined : metaData === null || metaData === void 0 ? void 0 : metaData[key],
        minValue: showMaxMin ? metaData === null || metaData === void 0 ? void 0 : metaData[minKey] : undefined,
        maxValue: showMaxMin ? metaData === null || metaData === void 0 ? void 0 : metaData[maxKey] : undefined,
        unit,
        separator: '-',
    });
};
exports.formatPotencyValue = formatPotencyValue;
const getIndustrySpecificPotencyValues = (metaData, industryTypeIds, isBlazePOS) => {
    const potencyValues = [];
    const addPotencyIfExists = (label, key, minKey, maxKey, defaultUnit) => {
        const value = (0, exports.formatPotencyValue)(metaData, key, minKey, maxKey, defaultUnit);
        if (value) {
            potencyValues.push({ label, value });
        }
    };
    if (!isBlazePOS) {
        addPotencyIfExists('THC', 'thc', 'minTHC', 'maxTHC', '%');
        addPotencyIfExists('CBD', 'cbd', 'minCBD', 'maxCBD', '%');
        return potencyValues;
    }
    const hasCbdHemp = industryTypeIds.includes(companies_1.IndustryTypeIds.CBD_HEMP);
    const hasLiquor = industryTypeIds.includes(companies_1.IndustryTypeIds.LIQUOR);
    const hasVape = industryTypeIds.includes(companies_1.IndustryTypeIds.VAPE);
    const hasSmoke = industryTypeIds.includes(companies_1.IndustryTypeIds.SMOKE);
    if (hasCbdHemp) {
        addPotencyIfExists('CBD', 'cbd', 'minCBD', 'maxCBD', '%');
        addPotencyIfExists('THC', 'thc', 'minTHC', 'maxTHC', '%');
    }
    if (hasLiquor) {
        addPotencyIfExists('ABV', 'abv', 'minABV', 'maxABV', '%');
        addPotencyIfExists('Proof', 'proof', 'minProof', 'maxProof', '');
    }
    if (hasVape || hasSmoke) {
        addPotencyIfExists('Nicotine Strength', 'nicotineStrength', 'minNicotineStrength', 'maxNicotineStrength', 'mg');
    }
    if (hasVape) {
        const showMaxMin = (metaData === null || metaData === void 0 ? void 0 : metaData.showMaxMin) === 'true';
        let pgValue = null;
        let vgValue = null;
        if (showMaxMin) {
            if ((metaData === null || metaData === void 0 ? void 0 : metaData.minPG) && (metaData === null || metaData === void 0 ? void 0 : metaData.maxPG)) {
                pgValue = `${metaData.minPG}-${metaData.maxPG}`;
            }
            if ((metaData === null || metaData === void 0 ? void 0 : metaData.minVG) && (metaData === null || metaData === void 0 ? void 0 : metaData.maxVG)) {
                vgValue = `${metaData.minVG}-${metaData.maxVG}`;
            }
        }
        else {
            if (metaData === null || metaData === void 0 ? void 0 : metaData.pg) {
                pgValue = `${metaData.pg}`;
            }
            if (metaData === null || metaData === void 0 ? void 0 : metaData.vg) {
                vgValue = `${metaData.vg}`;
            }
        }
        if (pgValue && vgValue) {
            potencyValues.push({ label: 'PG/VG Ratio', value: `${pgValue}/${vgValue}` });
        }
        else {
            if (pgValue) {
                potencyValues.push({ label: 'PG', value: `${pgValue}%` });
            }
            if (vgValue) {
                potencyValues.push({ label: 'VG', value: `${vgValue}%` });
            }
        }
    }
    return potencyValues;
};
exports.getIndustrySpecificPotencyValues = getIndustrySpecificPotencyValues;
//# sourceMappingURL=productUtilities.js.map